// extracted by mini-css-extract-plugin
module.exports = {"body":"mobilecontents_body__3M41c"};